import Match from 'global-utils/models/sports/soccer/Match'

import * as play from './PlayingNowActions'

export default (state = play.PLAYING_NOW_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case play.PLAYING_NOW_FETCH: {
      return state
    }
    case play.PLAYING_NOW_FETCH_CANCELED: {
      return state
    }
    case play.PLAYING_NOW_FETCH_ERROR: {
      return action.payload
    }
    case play.PLAYING_NOW_FETCH_FULFILLED: {
      const newState = action.payload
      newState.data.forEach((match, index) => {
        newState.data[index] = new Match(match)
      })
      return newState
    }
    default:
  }
  return state
}
